import channelService from '@/services/amio/channel.service'
import store from '@/store/store'

class ChannelModule {

  async setChannelList(botId) {
    const channelList = await channelService.channelList(botId)
    store.commit('CHANNEL_LIST_SET', channelList)
  }

  async setChannelListForBots(botIds) {
    const channelList = await channelService.channelListForBots(botIds)
    store.commit('CHANNEL_LIST_SET', channelList)
  }

  getChannelList() {
    return store.state.channelList
  }

  existsNonAmioChat() {
    return this.getChannelList().some(({ type }) => type !== 'amio_chat')
  }
}

export default new ChannelModule()
